export const VIETNAM_CITIES = [
  "Ha Noi",
  "Ho Chi Minh",
  "Da Nang",
  "Hai Phong",
  "Can Tho",
  "Quang Ninh",
  "Binh Duong",
  "Dong Nai",
  "Ha Nam",
  "Hung Yen",
  "Thai Nguyen",
  "Bac Giang",
  "Bac Kan",
  "Cao Bang",
  "Lang Son",
  "Tuyen Quang",
  "Lao Cai",
  "Yen Bai",
  "Son La",
  "Dien Bien",
  "Lai Chau",
  "Phu Tho",
  "Vinh Phuc",
  "Bac Ninh",
  "Thanh Hoa",
  "Nghe An",
  "Ha Tinh",
  "Quang Binh",
  "Quang Tri",
  "Thua Thien Hue",
  "Quang Nam",
  "Quang Ngai",
  "Binh Dinh",
  "Phu Yen",
  "Khanh Hoa",
  "Ninh Thuan",
  "Binh Thuan",
  "Tien Giang",
  "Long An",
  "Dong Thap",
  "An Giang",
  "Kien Giang",
  "Ca Mau",
  "Soc Trang",
  "Bac Lieu",
  "Vung Tau",
  "Ba Ria-Vung Tau",
  "Tay Ninh",
  "Binh Phuoc",
  "Gia Lai",
  "Dak Lak",
  "Dak Nong",
  "Lam Dong",
];
